import { O as AriaAttr } from './bxf-utils-3908c3c5.js';

/**
 * Returns the aria-disabled attribute if the element is disabled.
 */
function getAriaDisabledAttr(isDisabled) {
    return isDisabled ? { [AriaAttr.DISABLED]: 'true' } : {};
}

const BxfTabBarItemConstants = {
    // Tab detail specifiers
    DEFAULT_ICON_STATE: 'secondary',
    HOVER_ICON_STATE: 'secondary-button',
    DELETE_ICON_STATE: 'error',
    PIN_ICON: 'pin',
    DELETE_ICON: 'delete-small',
    CONTEXT_MENU_PIN: 'Pin Tab',
    CONTEXT_MENU_RENAME: 'Rename Tab',
    // CSS Classes
    CONTAINER_EDITING: 'bxf-tab-item__container--editing',
    CONTAINER_EDITING_MODERN: 'bxf-tab-item__container--editing-modern',
    CONTAINER_DISABLED: 'bxf-tab-item__container--disabled',
    TAB_HOVER_SELECTED: 'bxf-tab-item__tab-hover--selected',
    TAB_HOVER: 'bxf-tab-item__tab-hover',
    DELETE_HOVER_SELECTED: 'bxf-tab-item__delete-hover--selected',
    DELETE_HOVER: 'bxf-tab-item__delete-hover',
    LABEL_BUTTON: 'bxf-tab-item__label-button',
    // The extra space in the beginning of these classes are needed
    CONTAINER_SELECTED: ' bxf-tab-item__container--selected',
    CONTAINER_FIXED: ' bxf-tab-item__container--fixed',
    CONTAINER_FULL: ' bxf-tab-item__container--full',
    CONTAINER: 'bxf-tab-item__container',
    PIN_ICON_CONTAINER: 'bxf-tab-item__pin-icon-container',
    LABEL_INPUT: 'bxf-tab-item__label-input',
    LABEL_CONTAINER: 'bxf-tab-item__label-container',
    LABEL_DISABLED: ' bxf-tab-item__label--disabled',
    CLOSE_BUTTON: 'bxf-tab-item__close-button',
    CONTAINER_SLOT: 'bxf-tab-item__slot-container',
    // Modern tab bar item css
    CONTAINER_MODERN: ' bxf-tab-item__container-modern',
    CONTAINER_MODERN_SELECTED: ' bxf-tab-item__container-modern--selected',
    DELETE_HOVER_MODERN_SELECTED: 'bxf-tab-item__delete-hover-modern--selected',
};

export { BxfTabBarItemConstants as B, getAriaDisabledAttr as g };
